 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"framework","2":"0f1ac474","3":"styles","4":"48534b8e52e1b28c9c727c6ecbbd89b5e9652659","5":"30046c5e4809705545c84092e8d0cf1c86e76d07","9":"component---src-pages-404-tsx","10":"component---src-pages-about-index-tsx","11":"component---src-pages-blog-index-tsx","12":"component---src-pages-career-index-tsx","13":"component---src-pages-contacts-index-tsx","14":"component---src-pages-full-cycle-development-index-tsx","15":"component---src-pages-index-tsx","16":"component---src-pages-press-index-tsx","17":"component---src-pages-projects-ai-sales-index-tsx","18":"component---src-pages-projects-b-2-connect-index-tsx","19":"component---src-pages-projects-backlite-media-index-tsx","20":"component---src-pages-projects-brand-affinity-index-tsx","21":"component---src-pages-projects-convidi-index-tsx","22":"component---src-pages-projects-geopop-index-tsx","23":"component---src-pages-projects-index-tsx","24":"component---src-pages-projects-loyalty-manager-index-tsx","25":"component---src-pages-projects-maxima-telecom-index-tsx","26":"component---src-pages-projects-mosaic-index-tsx","27":"component---src-pages-projects-movie-teller-index-tsx","28":"component---src-pages-projects-nexus-mentis-index-tsx","29":"component---src-pages-projects-sportex-index-tsx","30":"component---src-pages-projects-video-sift-index-tsx","31":"component---src-pages-projects-your-stylist-index-tsx","32":"component---src-pages-sitemap-tsx","33":"component---src-templates-plain-text-page-plain-text-page-tsx"}[chunkId]||chunkId) + "-" + {"0":"9176adf4a647c6d2321d","1":"0bdfa3b8a28d04e531d8","2":"d46a56c8db849df6a87c","3":"365f87b8b168dadf8c1d","4":"8f321feda59bf00605b0","5":"573dbd7027c24130c53b","9":"0ca501b1012768645d8a","10":"98da4a4287af06586e79","11":"21586524e19d51480dae","12":"9a3ee0ccb217bd2db9ae","13":"de815e20b94ce088d5ee","14":"c39a725115d5a9f7f166","15":"5b056662bbb6252a3636","16":"0bc4279a1a4cbf53783f","17":"024c204e71cdd4f5277a","18":"1637d662f1933ec39bd1","19":"013deddd718a1ad9d0e1","20":"db2ded0599f64d4ba4d5","21":"2554a60505f2e20f8b5d","22":"52b912aac4ff5267beca","23":"1f1c0404e2a14507b060","24":"594e07ada32a7c28f6b6","25":"f07720b09d3fc7c2a9db","26":"a6db729da23b655af34d","27":"d7c01c6dbc988999185b","28":"c44f246fc5f706d76150","29":"bbe6c86dfaaaf358b7a8","30":"63d772200c1a25953b84","31":"b7cad66c165b7ecd914c","32":"dc7c3b5817b7e9b09b3f","33":"7f175e8174689e29e8f2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"framework","2":"0f1ac474","3":"styles","4":"48534b8e52e1b28c9c727c6ecbbd89b5e9652659","5":"30046c5e4809705545c84092e8d0cf1c86e76d07","9":"component---src-pages-404-tsx","10":"component---src-pages-about-index-tsx","11":"component---src-pages-blog-index-tsx","12":"component---src-pages-career-index-tsx","13":"component---src-pages-contacts-index-tsx","14":"component---src-pages-full-cycle-development-index-tsx","15":"component---src-pages-index-tsx","16":"component---src-pages-press-index-tsx","17":"component---src-pages-projects-ai-sales-index-tsx","18":"component---src-pages-projects-b-2-connect-index-tsx","19":"component---src-pages-projects-backlite-media-index-tsx","20":"component---src-pages-projects-brand-affinity-index-tsx","21":"component---src-pages-projects-convidi-index-tsx","22":"component---src-pages-projects-geopop-index-tsx","23":"component---src-pages-projects-index-tsx","24":"component---src-pages-projects-loyalty-manager-index-tsx","25":"component---src-pages-projects-maxima-telecom-index-tsx","26":"component---src-pages-projects-mosaic-index-tsx","27":"component---src-pages-projects-movie-teller-index-tsx","28":"component---src-pages-projects-nexus-mentis-index-tsx","29":"component---src-pages-projects-sportex-index-tsx","30":"component---src-pages-projects-video-sift-index-tsx","31":"component---src-pages-projects-your-stylist-index-tsx","32":"component---src-pages-sitemap-tsx","33":"component---src-templates-plain-text-page-plain-text-page-tsx"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"e79cf40b657b9a7576b6","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"framework","2":"0f1ac474","3":"styles","4":"48534b8e52e1b28c9c727c6ecbbd89b5e9652659","5":"30046c5e4809705545c84092e8d0cf1c86e76d07","9":"component---src-pages-404-tsx","10":"component---src-pages-about-index-tsx","11":"component---src-pages-blog-index-tsx","12":"component---src-pages-career-index-tsx","13":"component---src-pages-contacts-index-tsx","14":"component---src-pages-full-cycle-development-index-tsx","15":"component---src-pages-index-tsx","16":"component---src-pages-press-index-tsx","17":"component---src-pages-projects-ai-sales-index-tsx","18":"component---src-pages-projects-b-2-connect-index-tsx","19":"component---src-pages-projects-backlite-media-index-tsx","20":"component---src-pages-projects-brand-affinity-index-tsx","21":"component---src-pages-projects-convidi-index-tsx","22":"component---src-pages-projects-geopop-index-tsx","23":"component---src-pages-projects-index-tsx","24":"component---src-pages-projects-loyalty-manager-index-tsx","25":"component---src-pages-projects-maxima-telecom-index-tsx","26":"component---src-pages-projects-mosaic-index-tsx","27":"component---src-pages-projects-movie-teller-index-tsx","28":"component---src-pages-projects-nexus-mentis-index-tsx","29":"component---src-pages-projects-sportex-index-tsx","30":"component---src-pages-projects-video-sift-index-tsx","31":"component---src-pages-projects-your-stylist-index-tsx","32":"component---src-pages-sitemap-tsx","33":"component---src-templates-plain-text-page-plain-text-page-tsx"}[chunkId]||chunkId) + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
